import {
  getSessionStorageItem,
  removeSessionStorageItem,
  setSessionStorageItem,
} from '@utilities/helpers/storage.helper';

/**
 * Passkey 待導頁 URL 的 sessionStorage key。
 * @external https://innotech.atlassian.net/browse/IN-144178 - 新增 pending redirect 儲存 key，支援 reload 後再導頁
 */
export const PASSKEY_PENDING_REDIRECT_STORAGE_KEY = 'passkey:pendingRedirectUrl';

/**
 * 將 Passkey 待導頁 URL 寫入 sessionStorage。
 * @external https://innotech.atlassian.net/browse/IN-144178 - 提供 pending redirect 寫入能力
 */
export const setPendingPasskeyRedirectUrl = (url: string): boolean =>
  setSessionStorageItem(PASSKEY_PENDING_REDIRECT_STORAGE_KEY, url);

/**
 * 讀取並清除 Passkey 待導頁 URL，確保只消費一次。
 * @external https://innotech.atlassian.net/browse/IN-144178 - 提供 pending redirect 單次消費能力
 */
export const consumePendingPasskeyRedirectUrl = (): string | null => {
  const url = getSessionStorageItem(PASSKEY_PENDING_REDIRECT_STORAGE_KEY);
  removeSessionStorageItem(PASSKEY_PENDING_REDIRECT_STORAGE_KEY);
  return url;
};

/**
 * Safari/iOS：custom scheme 被「是否打開 App」取消後，同分頁再 replace 可能出現「網址無效」。
 * 先把目標 URL 存起來並 reload 清導覽狀態，載入後再 replace。
 * @external https://innotech.atlassian.net/browse/IN-144178 - 以 reload-then-replace 避開 iOS 取消後網址無效
 */
export const redirectViaReloadThenReplace = (url: string): void => {
  if (!setPendingPasskeyRedirectUrl(url)) {
    window.location.replace(url);
    return;
  }

  window.location.reload();
};

/**
 * 消費 pending redirect 並以 replace 導向目標 URL；無 pending 時回傳 false。
 * @external https://innotech.atlassian.net/browse/IN-144178 - 頁面載入後接續完成 pending redirect
 */
export const consumeAndReplacePendingPasskeyRedirect = (): boolean => {
  const url = consumePendingPasskeyRedirectUrl();
  if (!url) {
    return false;
  }

  window.location.replace(url);
  return true;
};
